import { CompanyRoleEnum, RoleEnum } from 'types/user';

import useCurrentLoggedInUser from './apollo/queries/useCurrentLoggedInUser';

export default function useRoleCheck() {
  const { role, companyRole } = useCurrentLoggedInUser();
  return {
    isAdmin: role === RoleEnum.ADMIN,
    isClient: role === RoleEnum.CLIENT,
    isNotary: role === RoleEnum.NOTARY,
    isSuperClient: companyRole === CompanyRoleEnum.ADMIN,
    isRegularClient: companyRole === CompanyRoleEnum.REGULAR,
    role,
    companyRole,
  };
}
